import type { FC } from 'react';
import type { MergeSVGProps } from './types';

import React from 'react';

type SvgComponentProps = MergeSVGProps<SVGSVGElement, { useCSS?: boolean }>;

const SvgComponent: FC<SvgComponentProps> = ({ useCSS = false, ...svgProps }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 42 42" {...svgProps}>
      <g
        className={useCSS ? 'origin-center animate-spin' : ''}
        style={{ ...(useCSS && { animationDuration: '600ms' }) }}
      >
        <path d="M0 0h42v42H0z" />
        <path
          stroke="currentColor"
          strokeWidth="var(--spinner-stroke-width, 3)"
          strokeLinecap="round"
          strokeMiterlimit={10}
          d="M38.6 21c0 .6 0 1.3-.1 1.9-.9 8.9-8.4 15.8-17.5 15.8-.6 0-1.2 0-1.7-.1"
        />
        {!useCSS && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 21 21"
            to="360 21 21"
            dur="600ms"
            repeatCount="indefinite"
          />
        )}
      </g>
    </svg>
  );
};

export default SvgComponent;
